import React from 'react';
import { ArrowRight } from 'lucide-react';
interface WineCardProps {
  label: string;
  name: string;
  description: string;
  delay: string;
  image?: string;
}
function WineCard({
  label,
  name,
  description,
  delay,
  image
}: WineCardProps) {
  return <div className={`flex flex-col items-center text-center transition-all duration-300 ease-out group h-full`} data-id="element-35">
      {/* Bottle Image or Placeholder */}
      <div className="w-36 h-[420px] mb-0 relative overflow-hidden" data-id="element-36">
        {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-37" /> : <>
            <div className="absolute inset-0 flex items-center justify-center text-charcoal/20 font-optima text-4xl opacity-20 rotate-90 whitespace-nowrap" data-id="element-38">
              {name}
            </div>
            {/* Silhouette hint */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-16 h-64 bg-charcoal/5" data-id="element-39"></div>
          </>}
      </div>

      {/* Thin separator line */}
      <div className="w-full h-px bg-charcoal/10 my-8" data-id="element-40"></div>

      <span className="text-label-sm uppercase tracking-wide-label font-light text-gold mb-3 block" data-id="element-41">
        {label}
      </span>
      <h3 className="text-2xl font-semibold text-charcoal font-optima mb-3" data-id="element-42">
        {name}
      </h3>
      <p className="text-base text-medium-gray mb-6 flex-grow" data-id="element-43">{description}</p>

      <a href="#" className="inline-flex items-center text-gold hover:underline underline-offset-4 transition-all mt-auto" data-id="element-44">
        <span className="uppercase tracking-wide-label text-xs font-semibold mr-2" data-id="element-45">
          Explore
        </span>
        <ArrowRight className="w-3 h-3" data-id="element-46" />
      </a>
    </div>;
}
export function FeaturedWinesSection() {
  return <>
      <div className="bg-white flex justify-center" data-id="element-47">
        <div className="w-full max-w-[200px] mx-auto" style={{
        height: '1px',
        backgroundColor: '#E8E8E8',
        marginTop: '30px',
        marginBottom: '30px'
      }} data-id="element-48" />
      </div>
      <section className="bg-white pt-[20px] pb-[60px] md:pt-[30px] md:pb-[80px] lg:pt-[40px] lg:pb-[120px] px-6" data-id="element-49">
        <div className="max-w-[1200px] mx-auto" data-id="element-50">
          <div className="text-center max-w-[900px] mx-auto mb-16" data-id="element-51">
            <h2 className="md:text-section-tablet lg:text-section-desktop text-charcoal mb-6 font-[500]" data-id="element-52">
              The Glenlofty Collection
            </h2>
            <p className="text-body text-charcoal" data-id="element-53">
              Our wines are a celebration of the Pyrenees. Crafted with
              precision and care, each bottle tells a story of its vintage and
              its place. From the classic elegance of our Estate Range to the
              premium Single Block wines and the vibrant GO Series, the
              Glenlofty collection offers a wine for every palate and occasion.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16 mb-16" data-id="element-54">
            <WineCard label="SINGLE BLOCK" name="Ridge Block Shiraz" description="Premium single-block wines of exceptional quality" delay="" image="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/SINGLE%20VINEYARD%20Ridge%20Shiraz.png" data-id="element-55" />
            <WineCard label="ESTATE RESERVE" name="Estate Shiraz" description="Classic expressions of our estate vineyard" delay="" image="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/ESTATE%20Cabernet%20Sauvignon.png" data-id="element-56" />
            <WineCard label="GO RANGE" name="GO Shiraz" description="Vibrant, youthful wines for immediate enjoyment" delay="" image="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GO%20Chardonnay.png" data-id="element-57" />
          </div>

          <div className="text-center" data-id="element-58">
            <button className="border border-charcoal bg-white text-charcoal px-16 py-4 uppercase tracking-[0.2em] font-medium hover:bg-charcoal hover:text-white hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out" data-id="element-59">
              View All Wines
            </button>
          </div>
        </div>
      </section>
    </>;
}